import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'bytesToMb',
    standalone: true
})
export class BytesToMbPipe implements PipeTransform {

  transform(value: number, ...args: number[]): string {
    return (Math.round(value / 1000000 * 100) / 100).toFixed(2);
  }

}
